import { transport } from 'config/transport';

export function callApiGetBHYTs(congDoanId, nunId) {
    return transport.get(`/congdoan/${congDoanId}/baohiemyte/${nunId}`);
}
